<template>
    <div class="user-center">
        <div class="user-center-panel">
            <img src="../assets/icon/user.png">
            <span v-if="$store.state.token">{{ userInfo.name }}</span>
            <span v-else>未登录</span>
        </div>
        <div class="user-center-menu">
            <van-cell icon="user-o" title="个人信息" is-link />
            <van-cell icon="friends-o" title="关于我们" is-link />
            <van-cell icon="upgrade" title="检查更新" is-link />
        </div>
        <div class="user-center-btn">
            <van-button v-if="$store.state.token" type="default" @click="logout">退出登录</van-button>
            <van-button v-else type="default" @click="login">登录</van-button>
        </div>
        <div class="contact-us">
            <span>联系我们</span>
            <br>
            <span>13051152786</span>
        </div>
    </div>
</template>

<script>
    import { Cell, CellGroup, Button } from 'vant'
    const { mixin } = require(`@/config/${process.env.VUE_APP_PROJECT}/user`)
    export default {
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Button.name]: Button,
        },
        mixins: [mixin],
        data() {
            return {
                userInfo: {
                    name: '',
                },
            }
        },
        created() {
            this.getUserInfo()
        },
        methods: {
            logout() {
                this.$store.commit('logout')
            },
            login() {
                this.$router.push({ name: 'Login' })
            },
        },
    }
</script>

<style lang="scss">
.user-center {
  &-panel {
    background-color: rgba(255, 255, 255, 1);
    height: 104px;
    border-radius: 6px;
    box-shadow: 0px 2px 8px rgba(206, 206, 206, 0.5);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 30px;
    img {
      width: 60px;
      height: 60px;
    }
    span {
      font-size: 13px;
      color: #000;
      margin-left: 20px;
    }
  }
  &-menu {
    padding: 5px;
  }
  &-btn{
      margin-top: 60px;
      text-align: center;
      .van-button{
          width: 30%;
      }
  }
  .contact-us{
      position: absolute;
      left: 0;
      bottom: 30px;
      text-align: center;
      width: 100%;
  }
}
</style>
